import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* Add Amplify imports */
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports';
import { ApiModule, BASE_PATH } from './swagger';

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth/auth.service';
import { CoreModule } from './core/core.module';
import { CommonModule as SdCommonModule } from './common/common.module';
// import { Device } from '@awesome-cordova-plugins/device/ngx';
import { StorageService } from './common/services/storage/storage.service';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicIconsModule } from './ionic-icons.module';

function storageFactory(storageService: StorageService) {
  return storageService.init.bind(storageService);
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/* Configure Amplify resources */
Amplify.configure(awsconfig);

// function authFactory(authService: AuthService): Promise<void> {
//   return authService.init.bind(authService);
// }

export function authFactory(authService: AuthService): () => Promise<void> {
  return () => authService.init();      // ← a zero-arg function returning Promise<void>
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  exports: [],
  imports: [
    AmplifyAuthenticatorModule,
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    IonicModule.forRoot(),
    IonicIconsModule.forRoot(),
    AppRoutingModule,
    CoreModule,
    ApiModule.forRoot(AuthService.getConfiguration),
    SdCommonModule,
    ZXingScannerModule,
    ReactiveFormsModule,
    FormsModule,
    GoogleMapsModule,
    NgxChartsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (storageFactory)(inject(StorageService));
        return initializerFn();
      }),
    provideAppInitializer(() => {
        const initializerFn = (authFactory)(inject(AuthService));
        return initializerFn();
      }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: BASE_PATH, useValue: environment.apiBaseUrl },
    // Device,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
